// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Ur-z","outfitFeedbackSection":"Vr-z"};